import classNames from 'clsx'

import {
  type HeroLcpImageDimensions,
  type HeroLcpSources,
  HOME_HERO_LCP_DIMENSIONS
} from '@/lib/lcp/heroLcpAssets'

import S from './HeroBlock.module.scss'

type HeroLcpBackgroundProps = {
  alt: string
  sources: HeroLcpSources
  className?: string
  dimensions?: Record<keyof HeroLcpSources, HeroLcpImageDimensions>
}

const HeroLcpBackground = ({
  alt,
  sources,
  className,
  dimensions = HOME_HERO_LCP_DIMENSIONS
}: HeroLcpBackgroundProps) => {
  return (
    <picture className={S.backgroundPicture}>
      <source
        media="(max-width: 768px)"
        srcSet={sources.mobile}
        type="image/webp"
      />
      <source
        media="(max-width: 992px)"
        srcSet={sources.tablet}
        type="image/webp"
      />
      <img
        src={sources.desktop}
        alt={alt}
        width={dimensions.desktop.width}
        height={dimensions.desktop.height}
        fetchPriority="high"
        loading="eager"
        decoding="sync"
        className={classNames(S.backgroundImage, className)}
      />
    </picture>
  )
}

export default HeroLcpBackground
